import React, { useEffect, useState } from "react";

import infoImg1 from "../../assets/images/contact/2.png";
import infoImg2 from "../../assets/images/contact/3.png";

import useStore from "../../store/information";

const ContactInfo = (props) => {
  const { totalInfo } = useStore();
  const [data, setData] = useState({});

  useEffect(() => {
    const ph1 = localStorage.getItem('ph1');
    const ph2 = localStorage.getItem('ph2');
    const email = localStorage.getItem('email');
    const address = localStorage.getItem('address');
    if (totalInfo) {
      setData({
        phoneNumber1: totalInfo?.phoneNumber || ph1,
        email: totalInfo?.email || email,
        phoneNumber2:totalInfo.names?.[4]?.name || ph2,
          address:totalInfo.names?.[4]?.name || address
      });
    }
  }, [totalInfo]);

  return (
    <ul className="address-sec">
      <li>
        <em className="icon">
          <img src={infoImg1} alt="" />
        </em>
        <span className="text">
          <em>Address</em> {data.address}
        </span>
      </li>
      <li>
        <em className="icon">
          <img src={infoImg2} alt="" />
        </em>
        <span className="text">
          <em>Contact</em>     <a href={`tel:(+95)${data.phoneNumber1}`}>(+95){data.phoneNumber1}</a>
          {/* <a href={`tel:(+95)${data.phoneNumber2}`}>(+95){data.phoneNumber2}</a> */}
          <a href={`mailto:${data.email}`}>{data.email}</a>
        </span>
      </li>
    </ul>
  );
};

export default ContactInfo;
